import { Vue, Component, Watch } from 'vue-property-decorator'
import { gatewayColumns, gatewayAppColumns, errInfoColumns,getNotOnlineColumns } from './data'
import { DashboardServiceProxy,GatewayServiceProxy } from '@/service-proxies/app-v2/iot-console.service-proxies'
import './index.less'
import { cloneDeep } from 'lodash'
import dayjs from 'dayjs'
import BarChart from './components/BarChart'
import PieChart from './components/PieChart'
import Activation from './components/Activation'
import DailyOnline from './components/DailyOnline'
import Collection from './components/Collection'
import OverDateCount from "./components/OverDateCount";

const dsp = new DashboardServiceProxy()
const gatewayServiceProxy = new GatewayServiceProxy()
const tableDataApi = {
  'frequentOnlineGateway': dsp.frequentOnlineGateway.bind(dsp, { current: 1, size: -1 }),
  'getMessageTopTen': dsp.getMessageTopTen.bind(dsp),
  'getAbnormalConnectionList': dsp.getAbnormalConnectionList.bind(dsp)
}

const simpleDataApi = {
  'getNodeList': dsp.getNodeList.bind(dsp),
  'statisticsGateway': dsp.statisticsGateway.bind(dsp),
  'getAbnormalConnectionTotal': dsp.getAbnormalConnectionTotal.bind(dsp),
  'getGatewayStatue': dsp.getGatewayStatue.bind(dsp)
}

@Component({
  BarChart,
  PieChart,
  Activation,
  DailyOnline,
  Collection,
  OverDateCount
})
export default class GatewayAnalysis extends Vue {

  loading = false
  errInfo = {}
  errorInfoMaps = {
    time: '触发时间',
    client: '客户端',
    server: '服务端',
    deviceCode: '网关编号',
    appId: 'APP',
    friendlyMessage: '信息',
    exception: '异常类型',
    exceptionMessage: '异常信息',
    exceptionStackMsg: '堆栈信息'
  }
  modalVisible = false
  basicData = [
    {
      title: '服务数量',
      key: 'getNodeList',
      text: '38',
      color: '#4a90e2',
      loading: false,
      dataSource: null,
      excute: (data) => data && data.items ? data.items.length : 0
    },
    {
      title: '在线网关数/总网关数',
      key: 'statisticsGateway',
      text: '46/6099',
      color: '#4a90e2',
      loading: false,
      dataSource: null,
      excute: (data) => data ? (data.online + '/' + data.total) : `0/0`
    },
    {
      title: '异常连接',
      key: 'getAbnormalConnectionTotal',
      text: '87',
      color: '#fa554c',
      loading: false,
      dataSource: null,
      excute: (data) => data ? data : '0'
    },
    {
      title: '仲裁服务运行状态',
      key: 'getGatewayStatue',
      text: '正常',
      color: (data) => data ? '#52c41a' : '#fa554c',
      loading: false,
      dataSource: null,
      excute: (data) => data ? '正常' : '异常'
    }
  ]
  tableMaps = [
    {
      title: '频繁上下线网关前10',
      key: 'frequentOnlineGateway',
      width: 'half',
      columns: gatewayColumns,
      tableData: [],
      scrollX: 480,
      pagination: null,
      loading: false
    },
    {
      title: '网关APP 5min内消息统计（前十）',
      key: 'getMessageTopTen',
      width: 'half',
      columns: gatewayAppColumns,
      tableData: [],
      scrollX: 480,
      pagination: null,
      loading: false
    },
    {
      title: '异常信息',
      key: 'getAbnormalConnectionList',
      width: 'full',
      columns: errInfoColumns(this.getOperationColumn),
      tableData: [],
      scrollX: 1500,
      pagination: {
        total: 0,
        pageSize: 10,
        current: 1
      },
      loading: false
    },
  ]
  nodeList = [] // 服务连接数统计
  statisticsGateway = {} // 网关状态数量统计
  currentTab = '1'
  onlineTab = '1'
  paginations={
    total: 0,
    pageSize: 10,
    current: 1
  }
  tableData=[]

  async created() {
    this.getTablesData()
    this.getBasicData()
    this.getnotOnlineDate()
  }

  pageIndexchange(val){
    this.paginations.current = val;
    this.getnotOnlineDate();
  }

  pageIndexchange2(val){
    this.tableMaps[2].pagination.current = val
    this.getTablesData();
  }


  getBasicData() {
    let temp = cloneDeep(this.basicData)
    Object.keys(simpleDataApi).map(k => {
      temp.map(async (item) => {
        if (item.key === k) {
          item.loading = true
          try {
            let res = await simpleDataApi[k]()
            item.dataSource = res
            // 获取柱状图数据
            if (k === 'getNodeList') {
              this.nodeList = res.items
            }
            // 获取饼图数据
            if (k === 'statisticsGateway') {
              this.statisticsGateway = res
            }
          } catch (e) {
            console.log(e)
          }
          item.loading = false
          this.basicData = cloneDeep(temp)
        }
      })
    })
  }

  getTablesData() {
    let temp = cloneDeep(this.tableMaps)
    Object.keys(tableDataApi).map(k => {
      temp.map(async (item) => {
        if (item.key === k) {
          item.loading = true
          try {
            if (k === 'getAbnormalConnectionList') {
              let { items, totalCount } = await tableDataApi[k](item.pagination?.current, item.pagination?.pageSize)
              item.tableData = items
              item.pagination.total = totalCount
            } else {
              let { items } = await tableDataApi[k]()
              item.tableData = items
            }
          } catch (e) {
            console.log(e)
          }
          item.loading = false
          this.tableMaps = cloneDeep(temp)
          // console.log('tableMaps:', this.tableMaps)
        }
      })
    })
  }

  async getnotOnlineDate() {
        let params:any = {
          ascs:"",
          current:this.paginations.current,
          days:"7",
          descs:"",
          filter:"",
          size:this.paginations.pageSize
        }
        if (this.onlineTab === "1") {
          params.days = "7"
        }
        if (this.onlineTab === "2") {
          params.days = "30"
        }
        if (this.onlineTab === "3") {
          params.days = "90"
        }
        let res = await gatewayServiceProxy.pageNotOnlineGateway(params)
        this.tableData = res.items
        this.paginations.total = res.totalCount
  }

  getOperationColumn(record) {
    return (
      <a
        href="javascript:;"
        onclick={() => this.openDetailModal(record)}
      >
        查看详情
      </a>
    )
  }

  renderSimpleCard(data) {
    const { title, color, dataSource, excute, loading } = data
    let newColor = typeof color === 'string' ? color : color(dataSource)
    return (
      <a-card loading={loading} title={title}>
        <span style={`font-size: 32px;color:${newColor};line-height: 40px;`}>{excute(dataSource)}</span>
      </a-card>
    )
  }

  renderCardWithTable() {
    return (
      <div class="table-card">
        {
          this.tableMaps.map(item => {
            const { title, columns, tableData, width, scrollX, pagination, loading } = item
            return (<a-card class={width} title={title}>
                <ml-table
                  loading={loading}
                  columns={columns}
                  dataSource={tableData}
                  canChangeColWidth={true}
                  scroll={{ y: 166, x: scrollX }}
                >
                </ml-table>
                {pagination &&<a-pagination
                  current={pagination?pagination.current:null}
                  total={pagination?pagination.total:null}
                  show-total={total => `${ this.showTotal(total) }`}
                  pageSize={pagination?pagination.pageSize:null}
                  style="float:right;margin-top:10px"
                  onChange={this.pageIndexchange2}
                  />}
              </a-card>
            )
          })
        }
      </div>
    )
  }

  renderNotOnlineTable() {
    return (
      <div class="table-card">
              <a-card class={'full'}>
                  <ml-table
                    loading={this.loading}
                    columns={getNotOnlineColumns}
                    dataSource={this.tableData}
                    canChangeColWidth={true}
                    pagination={false}
                    scroll={{ y: 155, x: 680 }}
                  >
                  </ml-table>
                  <a-pagination
                  current={this.paginations.current}
                  total={this.paginations.total}
                  show-total={total => `${ this.showTotal(total) }`}
                  pageSize={this.paginations.pageSize}
                  style="float:right;margin-top:10px"
                  onChange={this.pageIndexchange}
                  />
                </a-card>
      </div>
    )
  }

  renderDetailModal() {
    return (
      <a-modal
        onCancel={this.close}
        title="查看详情"
        visible={this.modalVisible}
        destroyOnClose={true}
        maskClosable={false}
        width={680}
      >
        <div slot="footer">
          <a-button
            style="margin-right:8px"
            onClick={this.close}
          >
            {this.$t('close')}
          </a-button>
        </div>
        {
          Object.keys(this.errorInfoMaps).map(k => {
            return (
              <a-form-item label={this.errorInfoMaps[k]} labelCol={{ span: 8 }} wrapperCol={{ span: 16 }}>
                <span style={{display: 'block',maxHeight: '200px',overflow: 'auto'}}>
                  {this.errInfo[k]}
                </span>
              </a-form-item>
            )
          })
        }
      </a-modal>
    )
  }

  renderNotOnline() {
    return (
      <a-tabs type="card" v-model={this.onlineTab} onChange={this.changetabs}>
      <a-tab-pane key="1" tab="超一周未上线网关">
      {this.renderNotOnlineTable()}
      </a-tab-pane>
      <a-tab-pane key="2" tab="超一月未上线网关">
      {this.renderNotOnlineTable()}
      </a-tab-pane>
      <a-tab-pane key="3" tab="超三月未上线网关">
      {this.renderNotOnlineTable()}
      </a-tab-pane>
    </a-tabs>
    )
  }

  openDetailModal(record) {
    this.modalVisible = true
    this.errInfo = Object.assign({}, record, {
      client: record.clientIp ? record.clientIp + ':' + record.clientPort : '',
      server: record.serveIp ? record.serveIp + ':' + record.servePort : '',
      time: record.time ? dayjs(record.time).format('YYYY-MM-DD HH:mm:ss') : ''
    })
  }

  changetabs() {
    this.paginations.current = 1
    this.getnotOnlineDate()
  }

  close() {
    this.modalVisible = false
  }

  showTotal(total){
    return (this.$t('Total…items') as string).replace('{0}', total)
  }

  renderBarChart() {
    if (!this.nodeList.length) {
      return
    }
    let temp = cloneDeep(this.nodeList)
    let columns = temp.map(item => (item.name))
    let data = temp.map(item => (item.load))
    // columns = ['192.168.1.20:10112', '192.168.1.20:10113', '192.168.1.10:10113', '192.168.1.21:10113']
    // data = [9, 4, 6, 2]
    return (
      <BarChart columns={columns} dataValue={data}/>
    )
  }

  renderPieChart() {
    if (!this.statisticsGateway.hasOwnProperty('online')) {
      return
    }
    let columns = [
      { name: '在线', color: '#52c41a', key: 'online' },
      { name: '离线', color: '#d8d8d8', key: 'offline' },
      { name: '未上线过', color: '#fa554c', key: 'neverOnline' },
      { name: '网关统计', color: '#4a90e2', key: 'total' }]
    return (
      <PieChart columns={columns} dataValue={this.statisticsGateway}/>
    )
  }

  // 服务连接数统计排行
  renderRankingList() {
    if (!this.nodeList.length) {
      return
    }
    let temp = cloneDeep(this.nodeList)
    temp.sort((a, b) => {
      return Number(b.load) - Number(a.load)
    })
    return (
      <div class="right">
        <div class="blue-title">
          服务连接数统计排行
        </div>
        <ul class="rank-list">
          {temp.map((item, index) => {
            return (
              <li>
                <span>{index + 1}</span>
                <span>{item.name}</span>
                <span>{item.load}个</span>
              </li>
            )
          })}
        </ul>
      </div>
    )
  }

  renderEmpty() {
    return (
      <div style="width: 100%; height: 150px; display: flex; justify-content: center; align-items: center;">
        <wm-empty text={this.$t('page_wm_empty')}/>
      </div>
    )
  }

  // 网关分析
  render() {
    return (
      <div class="gateway-exportAnalysis">
        <div class="basic-panel">
          {
            this.basicData?.map(item => (this.renderSimpleCard(item)))
          }
        </div>

        <div style="width:100%; margin-top:10px">
          <Activation></Activation>
        </div>
        <div style="width:100%; margin-top:10px">
          <DailyOnline></DailyOnline>
        </div>
        <div style="width:100%; margin-top:10px">
          <Collection></Collection>
        </div>
        <div style="width:100%; margin-top:10px">
          <OverDateCount></OverDateCount>
        </div>


        <div style="display:flex;justify-content: space-between;">
          <div style="width:49.5%">
            <a-tabs type="card" v-model={this.currentTab}>
          <a-tab-pane key="1" tab="服务连接统计">
            <div class="left">
              {this.renderBarChart()}
            </div>
            {this.renderRankingList()}
          </a-tab-pane>
          <a-tab-pane key="2" tab="网关状态数量统计">
            {this.renderPieChart()}
          </a-tab-pane>
        </a-tabs>
          </div>
          <div style="width:49.5%">
            {this.renderNotOnline()}
          </div>
          </div>
          {this.renderCardWithTable()}
          {this.renderDetailModal()}
        </div>
    )
  }
}
